var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F2E33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.5 4.38a5.093 5.093 0 0 1 5.093 5.092v2.295a2 2 0 0 0 .505 1.329l1.35 1.518c.86.968.173 2.497-1.121 2.497H5.674c-1.295 0-1.981-1.53-1.121-2.497l1.35-1.518a2 2 0 0 0 .505-1.329V9.472A5.093 5.093 0 0 1 11.5 4.38m0 0V1.833m-1.018 18.334h2.037"
  })));
};
export default SvgNotification;